import React from 'react'

import { WorkspaceSettingsEncryptionPanel } from '../../components'

interface WorkspaceSettingsEncryptionProps {
  workspaceId: string
  isEncryptionEnabled: boolean
  roleArn?: string
  encryptionKeys?: string[]
}

export const WorkspaceSettingsEncryption: React.FC<
  WorkspaceSettingsEncryptionProps
> = ({ workspaceId, encryptionKeys, roleArn }) => {
  return (
    <WorkspaceSettingsEncryptionPanel
      workspaceId={workspaceId}
      encryptionKeys={encryptionKeys}
      roleArn={roleArn}
    />
  )
}
